import { Button, Stack } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

interface GroupFormActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel: string;
  disabled?: boolean;
  loading?: boolean;
  cancelTestId?: string;
  submitTestId?: string;
}

export function GroupFormActions({
  onCancel,
  onSubmit,
  submitLabel,
  disabled = false,
  loading = false,
  cancelTestId = 'cancel-button',
  submitTestId = 'submit-button',
}: GroupFormActionsProps) {
  return (
    <Stack direction="row" spacing={2}>
      <Button
        variant="outlined"
        startIcon={<CancelIcon />}
        onClick={onCancel}
        disabled={loading}
        data-testid={cancelTestId}
        fullWidth
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        startIcon={<SaveIcon />}
        onClick={onSubmit}
        disabled={disabled || loading}
        data-testid={submitTestId}
        fullWidth
      >
        {submitLabel}
      </Button>
    </Stack>
  );
}
